var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { useFormLayoutContext } from '../form';
import { RowLayout } from '../row-layout';
import { styled } from '../styled';
import { fieldSetClasses, fieldSetComponentName, getFieldSetUtilityClass } from './field-set-classes';
import { Text } from '../text';
import clsx from '../utils/clsx';
import { useMergedClasses } from '../styles/classes';
var Root = styled('fieldset', {
    name: fieldSetComponentName,
    slot: 'Root',
})(function (_a) {
    var _b, _c;
    var theme = _a.theme, ownerState = _a.ownerState;
    return __assign({ display: 'grid', gridTemplateColumns: 'minmax(0,1fr)', gridGap: theme.spacing(3), alignItems: 'flex-start', border: 'none' }, (ownerState.layout === 'two-column' && (_b = {},
        _b[theme.breakpoints.up('md')] = (_c = {
                gridGap: theme.spacing(5),
                gridTemplateColumns: '2fr minmax(0,3fr)'
            },
            _c["& .".concat(fieldSetClasses.labelContent, ":empty")] = {
                display: 'grid',
            },
            _c),
        _b)));
});
var LabelContent = styled(RowLayout, {
    name: fieldSetComponentName,
    slot: 'LabelContent',
})({
    '&:empty': {
        display: 'none',
    },
});
export var FieldSet = React.forwardRef(function (props, ref) {
    var label = props.label, propLayout = props.layout, description = props.description, children = props.children, _a = props.margin, margin = _a === void 0 ? 'default' : _a, className = props.className, rootProps = __rest(props, ["label", "layout", "description", "children", "margin", "className"]);
    var layoutContext = useFormLayoutContext().layout;
    var classes = useMergedClasses(fieldSetClasses, getFieldSetUtilityClass, props.classes);
    var layout = propLayout || layoutContext;
    var ownerState = {
        layout: layout,
    };
    return (React.createElement(Root, __assign({ ref: ref, ownerState: ownerState, className: clsx(classes.root, className) }, rootProps),
        React.createElement(LabelContent, { gutter: 0.5, className: classes.labelContent },
            !!label && (React.createElement(Text, { variant: "subtitle1", color: "textPrimary", component: "legend", className: classes.labelText }, label)),
            !!description && (React.createElement(Text, { variant: "body2", color: "textSecondary", className: classes.descriptionText }, description))),
        React.createElement(RowLayout, { gutter: margin === 'dense' ? 2 : 3, className: classes.contentWrapper }, children)));
});
